import { createSelector } from 'reselect';
import _ from 'lodash';

import { StoreType } from '@tock/shared/utils/connect';

const serviceOrderMapping: { [service: string]: number } = {
  BREAKFAST: 1,
  BRUNCH: 2,
  LUNCH: 3,
  DINNER: 4,
};

export default createSelector(
  (state: StoreType) => state.features.features,
  (state: StoreType) => state.services.forWeekday,
  (state: StoreType) => state.publicHours.forWeekday,
  (features, servicesByWeekday, publicHoursByWeekday) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const serviceTypesObj: any = {};
    const servicesByDay = features.PUBLIC_HOURS_BASED_SERVICE_FILTER
      ? publicHoursByWeekday
      : servicesByWeekday;
    _.forEach(servicesByDay, (dayServices) => {
      _.forEach(dayServices, (service) => {
        serviceTypesObj[service.serviceType] = true;
      });
    });
    const serviceTypes = _.map(serviceTypesObj, (v, k) => {
      return k;
    });
    return _.filter(
      _.sortBy(serviceTypes, (serviceType) => {
        return serviceOrderMapping[serviceType];
      })
    );
  }
);
